import { handleActions } from 'redux-actions';
import { AppState } from '../types/store';
import { unsubscribeSuccess } from '../actions/emailUnsubscribe';

export default handleActions<AppState['emailUnsubscribe'], any>(
  {
    [`${unsubscribeSuccess}`]: (state, action) => ({
      ...state,
      hasUnsubscribedSuccessfully: true,
    }),
  },
  {}
);
